
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/token",
      function () {
        return require("private-next-pages/token.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/token"])
      });
    }
  